module.exports = __webpack_public_path__ + "img/icon40.31b2e487.png";